import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPriceToDkk(price: number) {
  return new Intl.NumberFormat("da-DK", {
    style: "currency",
    currency: "DKK",
    maximumFractionDigits: 2,
  })
    .format(price)
    .replaceAll(",00", "");
}

type ImageFormat = "webp" | "avif" | "jpg" | "png";
type ImageOptions = {
  format?: ImageFormat;
  width?: number | "auto";
  height?: number | "auto";
  quality?: number;
};

export function getImageUrl(
  locationId: string,
  image: string,
  options: ImageOptions = {}
): string {
  const defaultOptions = {
    format: "webp",
    width: 800,
    height: "auto",
  };

  const finalOptions = { ...defaultOptions, ...options };

  const baseUrl = `${import.meta.env.VITE_ASSETS_URL}/i/${locationId}/${image}`;

  const params = new URLSearchParams();
  Object.entries(finalOptions).forEach(([key, value]) => {
    if (value !== undefined) {
      params.append(key, String(value));
    }
  });

  return `${baseUrl}?${params.toString()}`;
}
